/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetUploadByIdQueryResponse, SocialExportGetUploadByIdPathParams, SocialExportGetUploadById401, SocialExportGetUploadById403, SocialExportGetUploadById404 } from "../models/SocialExportGetUploadById";

export function getSocialExportGetUploadByIdUrl(id: SocialExportGetUploadByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/social-export/v1/upload/${id}` as const }
  return res
}

/**
 * @description Returns upload details including status, platform data, and available platform features.
 * @summary Get an upload by ID
 * {@link /social-export/v1/upload/:id}
 */
export async function socialExportGetUploadById(id: SocialExportGetUploadByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportGetUploadByIdQueryResponse, ResponseErrorConfig<SocialExportGetUploadById401 | SocialExportGetUploadById403 | SocialExportGetUploadById404>, unknown>({ method : "GET", url : getSocialExportGetUploadByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}